<template>
  <div class="kt-grid kt-grid--ver kt-grid--root">
    <div
      class="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v6 kt-login--signin"
      id="kt_login"
    >
      <div
        class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile"
      >
        <div
          class="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside"
        >
          <div class="kt-login__wrapper">
            <div class="kt-login__container">
              <div class="kt-login__body auth-form">
                <div class="kt-login__logo">
                  <router-link :to="{ name: 'register' }">
                    <img :src="site.meta.default.logo" />
                  </router-link>
                </div>
                <div
                    v-if="firstStep" class="kt-login__register col-sm-12 col-md-12 col-lg-10 col-xl-8 col-12 mx-auto"
                >
                  <div class="kt-head px-0">
                    <h3 class="kt-title">Create New Account</h3>
                  </div>
                  <div>
                    <Alert v-if="recaptchaErr" variant="danger">
                      <div
                          class="d-flex justify-content-center align-items-center"
                      >
                        <div class="alert-icon">
                          <i class="flaticon-questions-circular-button"></i>
                        </div>
                        {{ recaptchaErr }}
                      </div>
                    </Alert>
                    <div
                        v-if="success"
                        class="alert alert-solid-success alert-bold fade show"
                        role="alert"
                    >
                      <div class="alert-icon">
                        <i class="flaticon2-check-mark"></i>
                      </div>
                      <div class="alert-text">{{ message }}</div>
                      <div class="alert-close">
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">
                            <i class="la la-close"></i>
                          </span>
                        </button>
                      </div>
                    </div>
                    <form class="kt-form" @submit.prevent="submit">
                      <div class="form-group">
                        <div class="row">
                          <div class="col">
                            <input
                              class="form-control"
                              type="text"
                              placeholder="First Name"
                              v-model="form.first_name"
                              :class="{ 'is-invalid': hasError('first_name') }"
                              @input="clearError('first_name')"
                            />
                            <span
                              class="form-text text-danger"
                              v-if="hasError('first_name')"
                            >
                              {{ getError("first_name") }}
                            </span>
                          </div>
                          <div class="col">
                            <input
                              class="form-control"
                              type="text"
                              placeholder="Last Name"
                              v-model="form.last_name"
                              :class="{ 'is-invalid': hasError('last_name') }"
                              @input="clearError('last_name')"
                            />
                            <span
                              class="form-text text-danger"
                              v-if="hasError('last_name')"
                            >
                              {{ getError("last_name") }}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <input
                          class="form-control"
                          type="email"
                          placeholder="Email"
                          v-model="form.email"
                          :class="{ 'is-invalid': hasError('email') }"
                          @input="clearError('email')"
                        />
                        <span
                          class="form-text text-danger"
                          v-if="hasError('email')"
                        >
                          {{ getError("email") }}
                        </span>
                      </div>

                      <div class="form-group">
                        <input
                            ref="phone"
                            v-model="form.phone"
                            :class="{ 'is-invalid': hasError('phone') }"
                            class="form-control"
                            placeholder="Phone"
                            type="text"
                            @blur="validatePhoneNumber"
                            @input="clearError('phone')"
                        />
                        <span
                            v-if="hasError('phone')"
                            class="form-text text-danger"
                        >
                          {{ getError("phone") }}
                        </span>

                        <!-- Default switch -->
                        <span style="margin-left: 150px; color: blue">I wan to receive a call</span>
                        <div class="custom-control custom-switch float-right">
                          <input id="customSwitches" v-model="form.callRequirement" class="custom-control-input"
                                 type="checkbox">
                          <label class="custom-control-label" for="customSwitches"></label>
                        </div>

                      </div>

                      <div class="form-group">
                        <input
                          class="form-control"
                          type="password"
                          placeholder="Password"
                          v-model="form.password"
                          :class="{ 'is-invalid': hasError('password') }"
                          @input="clearError('password')"
                        />
                        <span
                          class="form-text text-danger"
                          v-if="hasError('password')"
                        >
                          {{ getError("password") }}
                        </span>
                      </div>
                      <div class="form-group">
                        <input
                          class="form-control"
                          type="password"
                          placeholder="Confirm Password"
                          v-model="confirmPassword"
                          :class="{ 'is-invalid': confirmPasswordError !== '' }"
                          @input="confirmPasswordError = ''"
                        />
                        <span
                          class="form-text text-danger"
                          v-if="confirmPasswordError !== ''"
                        >
                          {{ confirmPasswordError }}
                        </span>
                      </div>

                      <div class="form-group">
                        <div
                            id="kt_login_signin_submit"
                            class="btn btn-brand w-100 btn-elevate"
                            @click="getStarted"
                        >
                          <div
                              class="d-flex justify-content-center align-items-center"
                          >
                            <span>Get Started</span>
                          </div>
                        </div>
                      </div>

                    <div class="kt-login__account" style="font-size: 1.2em;">
                      <span class="kt-login__account-msg">
                        Have an account?
                      </span>
                      <router-link
                          :to="{ name: 'login' }"
                          class="kt-login__account-link font-weight-bold ml-2"
                          style="font-size: inherit"
                      >
                        Log In!
                      </router-link>
                    </div>

                      <div class="mt-3">
                      <span>
                        By joining, you agree to our
                      <a :href="site.meta.register.terms_and_condition_link">
                        Terms of Service
                      </a>
                        and
                      <a href="#">
                        Privacy Policy
                      </a>
                    </span>
                      </div>

                    </form>

                  </div>
                </div>

                <div v-if="secondStep" class="kt-login__register col-sm-12 col-md-12 col-lg-10 col-xl-8 col-12 mx-auto">
                  <div>
                    <h3 class="kt-title">Confirm your email</h3>
                  </div>
                  <div>

                    <div
                        v-if="success"
                        class="alert alert-solid-success alert-bold fade show"
                        role="alert"
                    >
                      <div class="alert-icon">
                        <i class="flaticon2-check-mark"></i>
                      </div>
                      <div class="alert-text">{{ message }}</div>
                      <div class="alert-close">
                        <button
                            aria-label="Close"
                            class="close"
                            data-dismiss="alert"
                            type="button"
                        >
                          <span aria-hidden="true">
                            <i class="la la-close"></i>
                          </span>
                        </button>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="row">
                        <div class="col">
                          <input
                              v-model="verification_code"
                              :class="{ 'is-invalid': hasError('verification_code') }"
                              class="form-control"
                              placeholder="Enter Verification Code"
                              type="text"
                              @input="clearError('verification_code')"
                          />
                          <span
                              class="form-text text-danger"
                              v-if="verification.errorMessage"
                          >
                          {{ verification.errorMessage }}
                        </span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <a class="text-wrap" href="#" @click="backToFirstStep">Didn't receive an email</a>
                    </div>
                    <div class="form-group">
                      We have sent a verification code to {{ this.form.email }}, to make sure you are really you.
                      (Remember to check your spam)
                    </div>

                    <div class="form-group">
                      <button
                          id="kt_login_signin_submit"
                          :disabled="busy"
                          class="btn btn-brand w-100 btn-elevate"
                          type="submit"
                          @click="verify"
                      >
                        <div
                            class="d-flex justify-content-center align-items-center"
                        >
                          <span>Verify</span>
                          <div
                              v-if="busy"
                              class="spinner-border spinner-border-sm ml-2"
                              role="status"
                          >
                            <span class="sr-only">Loading...</span>
                          </div>
                        </div>
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
            :style="{ backgroundImage: `url(${ this.banner })` }"
            class="kt-grid__item kt-grid__item--fluid kt-grid__item--center kt-grid kt-grid--ver kt-login__content"
        >
          <div class="kt-login__section">
            <div class="kt-login__block mx-5">
              <h3 class="kt-login__title">
                {{ site.meta.register.hero_section_title }}
              </h3>
              <div class="kt-login__desc">
                {{ site.meta.register.hero_section_description }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Alert from "@/components/Alert.vue";
import intlTelInput from "intl-tel-input";
import ValidationErrorsMixin from "@/mixins/ValidationErrors.js";
import "intl-tel-input/build/css/intlTelInput.css";

export default {
  components: {
    Alert,
  },
  mixins: [ValidationErrorsMixin],

  data() {
    return {
      banner: '',
      form: {
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        password: "",
        callRequirement: false,
      },
      confirmPassword: "",
      confirmPasswordError: "",
      agree: false,
      success: false,
      message: "",
      busy: false,
      phoneInput: null,
      recaptchaErr: null,
      verification_code: null,
      firstStep: true,
      secondStep: false,
      verification: {
        errorMessage: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      site: "site/site",
    }),
    isDisabled() {
      if (this.form.phone && !this.phoneInput.isValidNumber()) {
        return true;
      }
      return !this.agree || this.busy;
    },
  },
  mounted() {
    this.banner = this.site.meta.register.banner;

    this.phoneInput = intlTelInput(this.$refs.phone, {
      separateDialCode: true,
      utilsScript:
          "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.min.js",
    });
  },
  methods: {
    ...mapActions({
      register: "auth/register",
      sendVerificationCode: "auth/sendVerificationCode",
      verifyCode: "auth/verify",
      login: "auth/login",
    }),
    validatePhoneNumber() {
      if (this.form.phone && !this.phoneInput.isValidNumber()) {
        this.errors = {
          ...this.errors,
          phone: ["Invalid phone number."],
        };
      }
    },
    submit() {
      this.busy = true;
      this.recaptchaErr = "";
    },

    getStarted() {

      if (this.busy) {
        return;
      }

      if (this.form.phone && !this.phoneInput.isValidNumber()) {
        return;
      }

      if (!this.form.email) {
        return;
      }

      this.confirmPasswordError = "";
      if (this.form.password !== this.confirmPassword) {
        this.confirmPasswordError = "The password confirmation does not match.";

        return;
      }

      this.firstStep = false;
      this.secondStep = true;
      this.banner = this.site.meta.register.second_banner
      this.verification.errorMessage = "";

      this.sendVerificationCode(this.form).then(() => {
      })
    },

    backToFirstStep() {
      this.secondStep = false;
      this.firstStep = true;
      this.banner = this.site.meta.register.banner

      this.form.email = "";
    },

    verify() {
      this.busy = true;

      var verificationData = Object.assign({}, this.form)
      verificationData["verification_code"] = this.verification_code

      this.verifyCode(verificationData)
          .then((data) => {
            if (data.data.success) {

              this.$recaptcha("register")
                  .then((token) => {
                    this.register({
                      ...this.form,
                      phone: this.phoneInput.getNumber(),
                      g_recaptcha_response: token,
                    })
                        .then(() => {
                          this.triggerGtmDataLayer();

                          this.success = true;

                          //after successful user creation, log in the user forcefully to dashboard
                          this.login({
                            credential: this.form,
                            remember: null,
                          })
                              .then(() => {
                                this.$router.replace({
                                  name: "home",
                                });
                              })
                        })
                        .catch((error) => {
                          this.busy = false;

                          this.backToFirstStep();
                          this.errors = error.response.data.errors;
                          if (this.errors["g_recaptcha_response"].length) {
                            this.recaptchaErr = this.errors["g_recaptcha_response"][0];
                          }
                        });
                  })
                  .catch(() => {
                    this.busy = false;
                    this.recaptchaErr = "Spam detected.";
                  });
            }

            if (!data.data.success) {
              this.verification.errorMessage = "Verification code mismatched";
              this.busy = false;
            }
          })
    },
    triggerGtmDataLayer() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "signup",
      });
    },
    reset() {
      this.form.first_name = "";
      this.form.last_name = "";
      this.form.phone = "";
      this.form.email = "";
      this.form.password = "";
      this.agree = false;
    },
  },
};
</script>

<style src="../../assets/css/auth.css"></style>
<style>
.grecaptcha-badge {
  visibility: hidden !important;
}
</style>
